import { render, staticRenderFns } from "./TalkrecordList.vue?vue&type=template&id=239dee10&scoped=true"
import script from "./TalkrecordList.vue?vue&type=script&lang=js"
export * from "./TalkrecordList.vue?vue&type=script&lang=js"
import style0 from "./TalkrecordList.vue?vue&type=style&index=0&id=239dee10&prod&lang=css"
import style1 from "./TalkrecordList.vue?vue&type=style&index=1&id=239dee10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239dee10",
  null
  
)

export default component.exports